import { Component, WritableSignal } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';
import { SpinnerComponent } from "../spinner/spinner.component";
import { style } from "@angular/animations";
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'toast',
  standalone: true,
  imports: [SpinnerComponent, TitleCasePipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  items!: WritableSignal<ToastItem[]>;
  constructor(public toast: ToastService) {
    this.items = toast.getItems();
  }

  protected readonly style = style;
}
export interface ToastItem {
  style: 'success'|'warning'|'error'|'info'|'loading',
  type: 'static'|'timed',
  message: string,
  time: number,
  elapsed: number
}
